(function () {
  'use strict';

  function cookieValue(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function activeCurrency() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return String(Shopify.currency.active || '');
      }
    } catch (e) {}
    // Fallback when Shopify.currency lags behind country switch
    var fromCookie = cookieValue('cart_currency') || cookieValue('currency');
    if (fromCookie) return String(fromCookie).toUpperCase();
    return '';
  }

  function money(cents, format) {
    cents = Math.round(Number(cents) || 0);
    var iso = activeCurrency();
    // Always prefer selected storefront currency so pack totals match the grid
    if (iso) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: iso,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      } catch (e) {}
    }
    var value = (cents / 100).toFixed(2);
    if (!format) return '$' + value;
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  // products.json returns presentment amounts as dollar strings ("22.00").
  // Never treat large whole numbers as "already cents" unless clearly from *.js API.
  function priceToCents(price) {
    if (price == null || price === '') return 0;
    if (typeof price === 'string') return Math.round(parseFloat(price, 10) * 100) || 0;
    if (typeof price === 'number') {
      // Integer cents from /products/x.js are typically >= 100 with no fraction
      if (Number.isInteger(price) && price >= 100) return price;
      return Math.round(price * 100) || 0;
    }
    return Math.round(parseFloat(price, 10) * 100) || 0;
  }

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function parseI18n(root) {
    var el = root.querySelector('[data-pack-i18n]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function tpl(str, map) {
    var out = String(str || '');
    Object.keys(map).forEach(function (key) {
      out = out.replace(new RegExp('\\[' + key + '\\]|\\{\\{' + key + '\\}\\}', 'g'), String(map[key]));
    });
    return out;
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 1000px)').matches;
  }

  function dollarsToCents(price) {
    return priceToCents(price);
  }

  function prepareCartSections() {
    // Start empty — invalid section ids (e.g. missing variant-added) break cart/add.js.
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      })
    );
    return sections;
  }

  function openThemeCartDrawer(cartContent, responseJson) {
    var items =
      responseJson && responseJson.items
        ? responseJson.items
        : responseJson
          ? [responseJson]
          : [];
    if (cartContent && responseJson && responseJson.sections) {
      cartContent.sections = responseJson.sections;
    }
    document.documentElement.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: items, cart: cartContent || {} }
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: cartContent || {} }
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );

    // Prefer theme cart drawer (Monster-style). Open Monster only if embed is enabled.
    var drawer = document.querySelector('cart-drawer#cart-drawer, cart-drawer, #cart-drawer');
    if (drawer) {
      if (typeof drawer.show === 'function') drawer.show();
      else if ('open' in drawer) drawer.open = true;
      else drawer.setAttribute('open', '');
      return;
    }

    try {
      if (typeof window.notifyMonsterUpsells === 'function') {
        window.notifyMonsterUpsells(cartContent || {});
      } else if (typeof window.monster_refresh === 'function') {
        window.monster_refresh();
      }
    } catch (eMonster) {}

    var monster = document.getElementById('monster-cart-wrapper');
    if (monster) {
      try {
        monster.classList.remove('mu_closed');
        monster.classList.add('mu_open');
        var overlay = document.querySelector('[class*="monster_upsell_overlay"]');
        if (overlay) overlay.style.display = '';
      } catch (eOpen) {}
    }
  }

  function PackBuilder(root) {
    this.root = root;
    this.i18n = parseI18n(root);
    this.productId = root.dataset.productId;
    this.productHandle = root.dataset.productHandle || '';
    this.productTitle = root.dataset.productTitle || '';
    this.variantId = root.dataset.variantId;
    this.basePrice = Number(root.dataset.basePrice || 0);
    this.comparePrice = Number(root.dataset.comparePrice || 0);
    this.productImage = root.dataset.productImage || '';
    this.moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    this.paidCollection = root.dataset.paidCollection || '';
    this.freeCollection = root.dataset.freeCollection || '';
    this.allowDuplicates = root.dataset.allowDuplicates !== 'false';
    this.showFilters = root.dataset.showFilters !== 'false';
    this.watchSize = '';
    this.materialFilter = 'best-sellers';
    this.colourChip = '';
    this.pickingIndex = 0;
    this.building = false;
    this.paidCache = null;
    this.freeCache = null;
    this.seedProduct = null;
    this.slots = [];
    this.packMemory = {};
    this.tierKey = '';
    this.cartLinkedPackId = null;
    this.cartLinkedVariantIds = [];

    this.mediaCol = document.querySelector('[data-pack-media-col]');
    this.workspace = document.querySelector('[data-pack-workspace]');
    this.sidebar = document.querySelector('[data-pack-sidebar]');
    this.drawer = document.querySelector('[data-pack-drawer]');

    this.priceCurrency = activeCurrency();
    this.productCache = {};
    this._repriceSlotsAfterLoad = false;

    this.mountWorkspace();
    this.bind();
    this.bindVariantSync();
    this.bindCartSync();
    this.bindCurrencySync();
    this.inferWatchSizeFromDom();
    this.preloadSeedProduct();
    this.loadPersistedPackState();
    var urlTier = null;
    try {
      urlTier = new URLSearchParams(window.location.search).get('bandify_pack');
    } catch (e) {}
    // Default: theme setting (client: 2 Pack so customers build bundles).
    // URL ?bandify_pack=1|2|3 still overrides for deep links / upgrade CTAs.
    var settingTier = this.root.getAttribute('data-default-tier') || '2';
    if (settingTier !== '1' && settingTier !== '2' && settingTier !== '3') settingTier = '2';
    var startTier = urlTier || settingTier;
    this.selectTier(startTier, true);
    // After restore: reprice if country just changed, or always refresh filled slots
    var pendingCurrency = false;
    try {
      pendingCurrency = sessionStorage.getItem('bfy_pack_currency_pending') === '1';
      if (pendingCurrency) sessionStorage.removeItem('bfy_pack_currency_pending');
    } catch (ePend) {}
    if (pendingCurrency || this._repriceSlotsAfterLoad) {
      this.ensureCurrencyPrices(true);
    } else {
      this.scheduleCurrencyReprice(false);
    }
    this.prefetchFreeCollection();
    if (urlTier === '3' || urlTier === '2') {
      var self = this;
      setTimeout(function () {
        try {
          self.enterBuildMode && self.enterBuildMode();
        } catch (e2) {}
        try {
          if (!isDesktop() && self.openMobileDrawer) self.openMobileDrawer();
        } catch (e3) {}
        try {
          self.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e4) {}
      }, 200);
    }
  }

  PackBuilder.prototype.inferWatchSizeFromDom = function () {
    var checked = document.querySelector('.product-info input[type="radio"]:checked');
    var text = checked ? String(checked.value || '') : '';
    if (/38|40|41/.test(text) && !/42|44|45|46|49/.test(text)) this.watchSize = '38/40/41mm';
    else if (/42|44|45|46|49/.test(text)) this.watchSize = '42/44/45/46/49mm';
  };

  PackBuilder.prototype.preloadSeedProduct = function () {
    // Kept for optional future use — Drool-style: nothing is auto-added to pack slots.
    this.seedProduct = null;
  };

  PackBuilder.prototype.mountWorkspace = function () {
    if (this.mediaCol && this.workspace && this.workspace.parentElement !== this.mediaCol) {
      this.mediaCol.appendChild(this.workspace);
    }
    var info = this.root.closest('.product-info') || document.querySelector('.product-info');
    if (info && this.sidebar && this.sidebar.parentElement !== info) {
      info.appendChild(this.sidebar);
    }
    // Mobile drawer must live on <body> so position:fixed is not trapped by theme transforms
    if (this.drawer && this.drawer.parentElement !== document.body) {
      document.body.appendChild(this.drawer);
    }
  };

  PackBuilder.prototype.bind = function () {
    var self = this;
    this.root.querySelectorAll('[data-tier]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.selectTier(btn.dataset.tier);
      });
    });

    var cta = qs(this.root, '[data-pack-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        self.onCta();
      });
    }

    document.querySelectorAll('[data-pack-exit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.exitBuildMode();
      });
    });

    if (this.sidebar) {
      var sideCta = qs(this.sidebar, '[data-sidebar-cta]');
      if (sideCta) {
        sideCta.addEventListener('click', function () {
          self.onSidebarCta();
        });
      }
    }

    if (this.drawer) {
      this.drawer.querySelectorAll('[data-pack-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.closeMobileDrawer();
        });
      });
    }

    if (this.workspace) {
      this.workspace.querySelectorAll('[data-material-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.setMaterialFilter(btn.dataset.materialFilter);
        });
      });
    }

    // If viewport crosses into mobile while desktop build UI is open,
    // tear it down so mobile pack panel is not shown twice with the sidebar.
    var mq = window.matchMedia('(min-width: 1000px)');
    var onViewport = function () {
      if (!isDesktop() && self.building) {
        self.exitBuildMode();
      }
      if (!isDesktop()) {
        if (self.workspace) self.workspace.hidden = true;
        if (self.sidebar) self.sidebar.hidden = true;
        document.documentElement.classList.remove('bandify-pack-building');
        self.building = false;
      }
    };
    if (mq.addEventListener) mq.addEventListener('change', onViewport);
    else if (mq.addListener) mq.addListener(onViewport);
  };

  PackBuilder.prototype.bindVariantSync = function () {
    var self = this;
    document.addEventListener('variant:change', function (event) {
      var detail = event.detail || {};
      var variant = detail.variant || detail;
      if (!variant || !variant.id) return;
      self.variantId = String(variant.id);
      self.basePrice = priceToCents(variant.price != null ? variant.price : self.basePrice);
      self.comparePrice = priceToCents(
        variant.compare_at_price != null ? variant.compare_at_price : self.comparePrice || 0
      );
      if (variant.featured_image && variant.featured_image.src) {
        self.productImage = variant.featured_image.src;
      }
      var opts = [variant.option1, variant.option2, variant.option3].filter(Boolean).join(' ');
      if (/mm/i.test(opts)) self.watchSize = opts;
      // PDP variant changes do NOT auto-fill pack slots (Drool behaviour).
      self.root.dataset.variantId = self.variantId;
      self.root.dataset.basePrice = String(self.basePrice);
      self.updateTierPrices();
      self.updateCtas();
      self.updateWorkspaceMeta();
    });
  };

  PackBuilder.prototype.bindCurrencySync = function () {
    var self = this;
    var check = function () {
      self.ensureCurrencyPrices(false);
    };
    document.addEventListener('currency:change', check);
    document.addEventListener('cart:refresh', check);
    window.addEventListener('pageshow', check);
    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t) return;
      var name = t.getAttribute && t.getAttribute('name');
      if (name === 'country_code' || name === 'currency' || name === 'locale_code') {
        setTimeout(check, 50);
        setTimeout(check, 400);
      }
    });
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form) return;
        var isLocalization =
          (form.action && String(form.action).indexOf('/localization') !== -1) ||
          (form.querySelector && form.querySelector('[name="country_code"], [name="currency"]'));
        if (!isLocalization) return;
        // About to switch country — mark so next load/reprice is forced
        try {
          sessionStorage.setItem('bfy_pack_currency_pending', '1');
        } catch (e) {}
      },
      true
    );
    setInterval(check, 1000);
  };

  // Soft refresh (same currency) vs hard wipe+fetch (currency changed / pending)
  PackBuilder.prototype.scheduleCurrencyReprice = function (forceWipe) {
    if (forceWipe) {
      this.ensureCurrencyPrices(true);
      return;
    }
    this._repriceSlotsAfterLoad = true;
    this.repriceFilledSlotsAsync();
  };

  PackBuilder.prototype.ensureCurrencyPrices = function (force) {
    var currency = activeCurrency();
    if (!currency && !force) return;
    if (!force && currency && currency === this.priceCurrency) return;

    var prev = this.priceCurrency;
    this.priceCurrency = currency || prev || '';
    this.productCache = {};
    this.paidCache = null;
    this.freeCache = null;
    this._activeProducts = [];
    this._repriceSlotsAfterLoad = true;

    // Keep selected bands, but wipe stale cents from memory so restore can't re-apply old FX
    Object.keys(this.packMemory || {}).forEach(
      function (key) {
        this.packMemory[key] = (this.packMemory[key] || []).map(function (slot) {
          if (!slot) return null;
          return {
            id: slot.id,
            productId: slot.productId,
            handle: slot.handle || '',
            isFree: !!slot.isFree,
            title: slot.title || '',
            image: slot.image || '',
            option1: slot.option1 || null,
            option2: slot.option2 || null,
            option3: slot.option3 || null,
            price: 0,
            compare: 0
          };
        });
      }.bind(this)
    );
    // Zero current slot prices immediately so UI doesn't flash old £8000-style numbers
    if (this.slots && this.slots.length) {
      for (var i = 0; i < this.slots.length; i++) {
        if (!this.slots[i]) continue;
        this.slots[i].price = 0;
        this.slots[i].compare = 0;
      }
      this.renderAllSlots();
      this.updateCtas();
    }
    this.persistPackState();
    this.loadProducts(true);
    this.prefetchFreeCollection();
    // Also fetch each filled product directly (.js = presentment cents)
    this.repriceFilledSlotsAsync();
  };

  PackBuilder.prototype.allCachedProducts = function () {
    var list = [];
    var seen = {};
    var pushAll = function (arr) {
      (arr || []).forEach(function (p) {
        if (!p || seen[p.id]) return;
        seen[p.id] = true;
        list.push(p);
      });
    };
    pushAll(this._activeProducts);
    pushAll(this.paidCache);
    pushAll(this.freeCache);
    var cache = this.productCache || {};
    Object.keys(cache).forEach(function (key) {
      pushAll(cache[key]);
    });
    return list;
  };

  PackBuilder.prototype.repriceFilledSlots = function () {
    var self = this;
    var products = this.allCachedProducts();
    if (!products.length) return false;
    var changed = false;
    for (var i = 0; i < this.slots.length; i++) {
      var slot = this.slots[i];
      if (!slot || !slot.id) continue;
      var product =
        products.find(function (p) {
          return Number(p.id) === Number(slot.productId);
        }) ||
        products.find(function (p) {
          return p.handle && slot.handle && p.handle === slot.handle;
        });
      if (!product) continue;
      var variant = (product.variants || []).find(function (v) {
        return Number(v.id) === Number(slot.id);
      });
      if (!variant) variant = self.pickVariantFromProduct(product, slot.id);
      var next = self.slotFromProduct(product, variant, !!slot.isFree);
      if (!next) continue;
      self.slots[i] = next;
      changed = true;
    }
    if (changed) {
      this.rememberCurrentPack();
      this.renderAllSlots();
      this.updateCtas();
      this.updateWorkspaceMeta();
      this.updateUnlockBanner();
    }
    return changed;
  };

  // Guaranteed reprice: fetch each filled product handle in current presentment currency
  PackBuilder.prototype.repriceFilledSlotsAsync = function () {
    var self = this;
    if (!this.slots || !this.slots.length) return;
    if (this._repriceInFlight) return;
    this._repriceInFlight = true;
    var currency = activeCurrency();
    var jobs = [];
    this.slots.forEach(function (slot, index) {
      if (!slot || !slot.id) return;
      var handle = slot.handle;
      if (!handle) return;
      var url =
        '/products/' +
        encodeURIComponent(handle) +
        '.js?currency=' +
        encodeURIComponent(currency || '') +
        '&_=' +
        String(Date.now());
      jobs.push(
        fetch(url, {
          credentials: 'same-origin',
          cache: 'no-store'
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (product) {
            if (!product || !product.variants) return;
            var variant = (product.variants || []).find(function (v) {
              return Number(v.id) === Number(slot.id);
            });
            if (!variant) variant = self.pickVariantFromProduct(product, slot.id);
            var next = self.slotFromProduct(product, variant, !!slot.isFree);
            if (!next) return;
            self.slots[index] = next;
          })
          .catch(function () {})
      );
    });
    if (!jobs.length) {
      this._repriceInFlight = false;
      this.repriceFilledSlots();
      return;
    }
    Promise.all(jobs).then(function () {
      self.priceCurrency = activeCurrency() || self.priceCurrency;
      self.rememberCurrentPack();
      self.renderAllSlots();
      self.updateCtas();
      self.updateWorkspaceMeta();
      self.updateUnlockBanner();
      self._repriceSlotsAfterLoad = false;
      self._repriceInFlight = false;
    }).catch(function () {
      self._repriceInFlight = false;
    });
  };

  PackBuilder.prototype.paidFilledCount = function () {
    var n = 0;
    for (var i = 0; i < this.paid; i++) if (this.slots[i]) n++;
    return n;
  };

  PackBuilder.prototype.freeFilledCount = function () {
    var n = 0;
    for (var i = this.paid; i < this.totalSlots; i++) if (this.slots[i]) n++;
    return n;
  };

  PackBuilder.prototype.phase = function () {
    if (this.totalSlots <= 1) return 'single';
    if (this.paidFilledCount() < this.paid) return 'paid';
    if (this.free > 0 && this.freeFilledCount() < this.free) return 'free';
    return 'complete';
  };

  PackBuilder.prototype.freeUnlocked = function () {
    return this.free > 0 && this.paidFilledCount() >= this.paid;
  };

  PackBuilder.prototype.currentTierBtn = function () {
    return this.root.querySelector('.bandify-pack-builder__tier.is-selected');
  };

  PackBuilder.prototype.storageKey = function () {
    return 'bandify_pack_state_' + String(this.productId || this.productHandle || 'p');
  };

  PackBuilder.prototype.persistPackState = function () {
    try {
      sessionStorage.setItem(
        this.storageKey(),
        JSON.stringify({
          currency: activeCurrency() || this.priceCurrency || '',
          packMemory: this.packMemory,
          tierKey: this.tierKey,
          cartLinkedPackId: this.cartLinkedPackId,
          cartLinkedVariantIds: this.cartLinkedVariantIds
        })
      );
    } catch (e) {}
  };

  PackBuilder.prototype.loadPersistedPackState = function () {
    try {
      var raw = sessionStorage.getItem(this.storageKey());
      if (!raw) return;
      var data = JSON.parse(raw);
      var savedCurrency = data && data.currency ? String(data.currency).toUpperCase() : '';
      var nowCurrency = String(activeCurrency() || '').toUpperCase();
      var pending = false;
      try {
        pending = sessionStorage.getItem('bfy_pack_currency_pending') === '1';
      } catch (e2) {}
      if (data && data.packMemory && typeof data.packMemory === 'object') {
        this.packMemory = data.packMemory;
        var currencyMismatch =
          pending || (savedCurrency && nowCurrency && savedCurrency !== nowCurrency);
        // Old sessions without currency key still need a soft reprice once
        if (currencyMismatch || !savedCurrency) {
          this._repriceSlotsAfterLoad = true;
        }
        if (currencyMismatch) {
          // Strip stale cents before selectTier restores slots
          Object.keys(this.packMemory).forEach(
            function (key) {
              this.packMemory[key] = (this.packMemory[key] || []).map(function (slot) {
                if (!slot) return null;
                var copy = {};
                Object.keys(slot).forEach(function (k) {
                  copy[k] = slot[k];
                });
                copy.price = 0;
                copy.compare = 0;
                return copy;
              });
            }.bind(this)
          );
        }
      }
      if (data && data.cartLinkedPackId) this.cartLinkedPackId = data.cartLinkedPackId;
      if (data && Array.isArray(data.cartLinkedVariantIds)) {
        this.cartLinkedVariantIds = data.cartLinkedVariantIds.map(String);
      }
    } catch (e) {}
  };

  PackBuilder.prototype.rememberCurrentPack = function () {
    if (this.tierKey && this.slots && this.slots.length > 1) {
      this.packMemory[this.tierKey] = this.slots.slice();
      this.persistPackState();
    }
  };

  PackBuilder.prototype.slotHasContent = function (list) {
    return !!(list && list.some(function (s) {
      return !!s;
    }));
  };

  PackBuilder.prototype.restorePackSlots = function (carryFrom) {
    var key = this.tierKey;
    var remembered = key && this.packMemory[key] ? this.packMemory[key].slice() : null;
    var next = new Array(this.totalSlots).fill(null);
    var source = null;
    // Prefer this tier's memory; otherwise keep current selections when switching packs
    if (this.slotHasContent(remembered)) source = remembered;
    else if (this.slotHasContent(carryFrom)) source = carryFrom;

    if (source && source.length) {
      for (var i = 0; i < this.totalSlots; i++) {
        next[i] = i < source.length && source[i] ? source[i] : null;
      }
    }
    this.slots = next;
    var firstEmpty = this.slots.findIndex(
      function (s, idx) {
        if (s) return false;
        if (idx >= this.paid && !this.freeUnlocked()) return false;
        return true;
      }.bind(this)
    );
    this.pickingIndex = firstEmpty < 0 ? 0 : firstEmpty;
  };

  PackBuilder.prototype.selectTier = function (tier, silent) {
    var self = this;
    this.root.querySelectorAll('[data-tier]').forEach(function (btn) {
      var on = btn.dataset.tier === String(tier);
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var btn = this.currentTierBtn();
    if (!btn) return;

    // Keep filled pack selections when switching Single ↔ 2/3 Pack
    var prevSlots = this.slots ? this.slots.slice() : [];
    this.rememberCurrentPack();

    this.paid = Number(btn.dataset.paid || 1);
    this.free = Number(btn.dataset.free || 0);
    this.percent = Number(btn.dataset.percent || 0);
    this.tierTitle =
      btn.dataset.title || btn.querySelector('.bandify-pack-builder__tier-title').textContent.trim();
    this.totalSlots = this.paid + this.free;
    this.tierKey = String(this.paid) + '+' + String(this.free);
    this.restorePackSlots(prevSlots);
    this.rememberCurrentPack();

    document.documentElement.classList.toggle('bandify-pack-mode-multi', this.totalSlots > 1);
    this.updateTierPrices();
    this.renderSidebarTabs();
    this.renderAllSlots();
    this.updateCtas();
    this.updateWorkspaceMeta();
    this.updateUnlockBanner();

    var mobilePanel = qs(this.root, '[data-pack-mobile]');
    if (mobilePanel) mobilePanel.hidden = this.totalSlots <= 1;

    if (this.totalSlots <= 1) {
      if (this.building) this.exitBuildMode();
      this.closeMobileDrawer();
      return;
    }

    // Desktop: open gallery-swap builder. Mobile: Screen 1 — slots on PDP.
    if (!silent) {
      if (isDesktop()) this.enterBuildMode();
      else {
        this.building = false;
        document.documentElement.classList.remove('bandify-pack-building');
        if (this.workspace) this.workspace.hidden = true;
        if (this.sidebar) this.sidebar.hidden = true;
        this.closeMobileDrawer();
        this.renderAllSlots();
        this.updateCtas();
        if (mobilePanel) {
          try {
            mobilePanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } catch (e) {}
        }
      }
    } else if (this.building && isDesktop()) {
      this.loadProducts(true);
    }
  };

  PackBuilder.prototype.discountedUnit = function (cents) {
    // Only apply % when a real pack % is configured. Do not invent discounts
    // that Shopify will not apply at cart/checkout.
    var pct = Number(this.percent) || 0;
    if (pct <= 0) return Math.round(Number(cents) || 0);
    return Math.round((Number(cents) * (100 - pct)) / 100);
  };

  PackBuilder.prototype.slotSalePrice = function (slot) {
    if (!slot) return 0;
    return Math.round(Number(slot.price) || 0);
  };

  PackBuilder.prototype.slotRetailPrice = function (slot) {
    // Full / RRP (compare_at). Client: show "You save" from retail, not sale.
    // e.g. Milanese retail ~$80, not the $40 sale price.
    if (!slot) return 0;
    var sale = Math.round(Number(slot.price) || 0);
    var compare = Math.round(Number(slot.compare) || 0);
    return compare > sale ? compare : sale;
  };

  PackBuilder.prototype.packTotal = function () {
    // Pay for filled paid slots only. Free = $0 (BXGY).
    var sum = 0;
    for (var i = 0; i < this.paid; i++) {
      var slot = this.slots[i];
      if (!slot) continue;
      sum += this.discountedUnit(slot.price);
    }
    return sum;
  };

  PackBuilder.prototype.compareTotal = function () {
    // Strikethrough / "You save" baseline = sum of RETAIL prices for every
    // filled band (paid + free). Client request: full price, not sale price.
    var sum = 0;
    for (var i = 0; i < this.totalSlots; i++) {
      var slot = this.slots[i];
      if (!slot) continue;
      sum += this.slotRetailPrice(slot);
    }
    return sum;
  };

  PackBuilder.prototype.saveAmount = function () {
    // Retail pack value − what customer pays (paid sale prices only).
    return Math.max(this.compareTotal() - this.packTotal(), 0);
  };

  PackBuilder.prototype.updateTierPrices = function () {
    // Tier card prices hidden by design (Single / 2 Pack / 3 Pack show title + badges only).
  };

  PackBuilder.prototype.filledCount = function () {
    return this.slots.filter(Boolean).length;
  };

  PackBuilder.prototype.mapVars = function () {
    var phase = this.phase();
    var remainingPaid = Math.max(this.paid - this.paidFilledCount(), 0);
    var remainingFree = Math.max(this.free - this.freeFilledCount(), 0);
    var current = this.pickingIndex;
    if (current == null || current < 0) {
      current = this.slots.findIndex(function (s) {
        return !s;
      });
    }
    if (current < 0) current = this.totalSlots - 1;
    return {
      count: String(this.totalSlots),
      slots: String(this.totalSlots),
      total: money(this.packTotal(), this.moneyFormat),
      compare: money(this.compareTotal(), this.moneyFormat),
      remaining: String(Math.max(this.totalSlots - this.filledCount(), 0)),
      remainingPaid: String(remainingPaid),
      remainingFree: String(remainingFree),
      filled: String(this.filledCount()),
      free: String(this.free),
      paid: String(this.paid),
      current: String(current + 1),
      n: String(current + 1),
      size: this.watchSize || 'selected size',
      percent: String(this.percent),
      phase: phase
    };
  };

  PackBuilder.prototype.updateMobileProgress = function () {
    var panel = qs(this.root, '[data-pack-mobile]');
    if (!panel || panel.hidden) return;
    var map = this.mapVars();
    var phase = this.phase();
    var title = qs(panel, '[data-mobile-pack-title]');
    var sizeNote = qs(panel, '[data-mobile-size-note]');
    var progress = qs(panel, '[data-mobile-progress]');
    var summary = qs(panel, '[data-mobile-summary]');

    if (title) {
      if (phase === 'complete') {
        title.textContent = 'Your ' + this.totalSlots + ' bands ✓ complete';
        title.classList.add('is-complete');
      } else {
        title.textContent = 'Your ' + this.totalSlots + ' bands';
        title.classList.remove('is-complete');
      }
    }
    if (sizeNote) {
      if (this.watchSize) {
        sizeNote.hidden = false;
        sizeNote.textContent = 'Watch size: ' + this.watchSize.replace(/mm$/i, '') + 'mm';
      } else {
        sizeNote.hidden = true;
      }
    }
    if (progress) {
      if (phase === 'complete') {
        progress.hidden = true;
      } else if (phase === 'paid') {
        progress.hidden = false;
        progress.innerHTML =
          '<span>' +
          this.paidFilledCount() +
          ' of ' +
          this.paid +
          ' paid bands chosen</span>' +
          (this.free
            ? '<span class="bandify-pack-mobile__progress-free">' +
              this.free +
              ' FREE waiting</span>'
            : '');
      } else {
        progress.hidden = false;
        progress.innerHTML =
          '<span class="bandify-pack-mobile__progress-free">' +
          this.freeFilledCount() +
          ' of ' +
          this.free +
          ' FREE bands chosen</span>';
      }
    }
    if (summary) {
      if (phase === 'complete') {
        summary.hidden = false;
        var bandsLabel = qs(summary, '[data-mobile-bands-label]');
        var compareEl = qs(summary, '[data-mobile-compare]');
        var totalEl = qs(summary, '[data-mobile-total]');
        var saveEl = qs(summary, '[data-mobile-save]');
        if (bandsLabel) bandsLabel.textContent = this.totalSlots + ' bands';
        if (compareEl) compareEl.textContent = money(this.compareTotal(), this.moneyFormat);
        if (totalEl) totalEl.textContent = money(this.packTotal(), this.moneyFormat);
        if (saveEl) saveEl.textContent = money(this.saveAmount(), this.moneyFormat);
      } else {
        summary.hidden = true;
      }
    }
  };

  PackBuilder.prototype.updateCtas = function () {
    var map = this.mapVars();
    var phase = this.phase();
    var cta = qs(this.root, '[data-pack-cta]');
    var sideCta = this.sidebar ? qs(this.sidebar, '[data-sidebar-cta]') : null;
    var mobileMode = !isDesktop() && this.totalSlots > 1;

    this.updateMobileProgress();

    // Single → use theme default ATC only (hide pack CTA to avoid double buttons)
    if (this.totalSlots <= 1) {
      if (cta) {
        cta.hidden = true;
        cta.setAttribute('aria-hidden', 'true');
      }
      if (sideCta) sideCta.disabled = true;
      return;
    }

    if (cta) {
      cta.hidden = false;
      cta.removeAttribute('aria-hidden');
      if (mobileMode) {
        // Mobile Screen 1/3 CTA copy — paid phase opens picker (do not leave CTA dead)
        if (phase === 'paid') {
          cta.textContent = tpl(this.i18n.ctaBuild || 'Build my pack • [total]', map);
          cta.disabled = false;
        } else if (phase === 'free') {
          cta.textContent = tpl(
            Number(map.remainingFree) === 1
              ? this.i18n.ctaFreeOne || 'Add 1 FREE band'
              : this.i18n.ctaFree || 'Add [remainingFree] FREE bands',
            map
          );
          cta.disabled = false;
        } else {
          cta.textContent = tpl(
            this.i18n.ctaComplete || 'Add [count] bands to cart • [total]',
            map
          );
          cta.disabled = false;
        }
      } else if (!this.building) {
        cta.textContent = tpl(this.i18n.ctaBuild || 'Build my pack • [total]', map);
        cta.disabled = false;
      } else if (phase === 'paid') {
        cta.textContent = tpl(
          this.i18n.ctaUnlock || 'Add [remainingPaid] more to unlock [free] FREE',
          map
        );
        cta.disabled = false;
      } else if (phase === 'free') {
        cta.textContent = tpl(
          Number(map.remainingFree) === 1
            ? this.i18n.ctaFreeOne || 'Add 1 FREE band'
            : this.i18n.ctaFree || 'Add [remainingFree] FREE bands',
          map
        );
        cta.disabled = false;
      } else {
        cta.textContent = tpl(this.i18n.ctaComplete || 'Add [count] bands to cart • [total]', map);
        cta.disabled = false;
      }
    }

    if (sideCta) {
      if (phase === 'paid') {
        sideCta.disabled = true;
        sideCta.textContent = tpl(
          this.i18n.ctaUnlock || 'Add [remainingPaid] more to unlock [free] FREE',
          map
        );
      } else if (phase === 'free') {
        sideCta.disabled = true;
        sideCta.textContent = tpl(
          Number(map.remainingFree) === 1
            ? this.i18n.ctaFreeOne || 'Add 1 FREE band'
            : this.i18n.ctaFree || 'Add [remainingFree] FREE bands',
          map
        );
      } else {
        sideCta.disabled = false;
        sideCta.textContent = tpl(
          this.i18n.ctaComplete || 'Add [count] bands to cart • [total]',
          map
        );
      }
    }

    if (this.sidebar) {
      var compareEl = qs(this.sidebar, '[data-sidebar-compare]');
      var totalEl = qs(this.sidebar, '[data-sidebar-total]');
      var saveEl = qs(this.sidebar, '[data-sidebar-save]');
      var saveRow = qs(this.sidebar, '.bandify-pack-sidebar__save-row');
      var titleEl = qs(this.sidebar, '[data-sidebar-title]');
      var totalCents = this.packTotal();
      var compareCents = this.compareTotal();
      var saveCents = this.saveAmount();
      if (totalEl) totalEl.textContent = money(totalCents, this.moneyFormat);
      if (compareEl) {
        if (compareCents > totalCents) {
          compareEl.hidden = false;
          compareEl.textContent = money(compareCents, this.moneyFormat);
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }
      if (saveEl) saveEl.textContent = money(saveCents, this.moneyFormat);
      if (saveRow) saveRow.hidden = saveCents <= 0;
      if (titleEl) {
        titleEl.textContent =
          'Your ' + this.tierTitle + (this.free ? ' + ' + this.free + ' FREE' : '');
      }
    }

    this.updateUnlockBanner();
  };

  PackBuilder.prototype.updateUnlockBanner = function () {
    if (!this.workspace) return;
    var banner = qs(this.workspace, '[data-unlock-banner]');
    if (!banner) return;
    var unlocked = this.freeUnlocked();
    banner.hidden = !unlocked || this.phase() === 'complete';
    if (unlocked) {
      var map = this.mapVars();
      if (Number(this.percent) > 0) {
        banner.textContent = tpl(
          this.i18n.unlockBanner || 'You’ve unlocked [percent]% off and [free] FREE bands',
          map
        );
      } else {
        banner.textContent = tpl(
          this.i18n.unlockBannerFreeOnly || 'You’ve unlocked [free] FREE bands — pick them next',
          map
        );
      }
    }
  };

  PackBuilder.prototype.renderSidebarTabs = function () {
    if (!this.sidebar) return;
    var host = qs(this.sidebar, '[data-sidebar-tabs]');
    if (!host) return;
    var self = this;
    host.innerHTML = '';
    this.root.querySelectorAll('[data-tier]').forEach(function (btn) {
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className =
        'bandify-pack-sidebar__tab' + (btn.classList.contains('is-selected') ? ' is-selected' : '');
      if (btn.dataset.tier === '1') tab.textContent = 'Single';
      else if (btn.dataset.tier === '2') tab.textContent = '2 + 2 FREE';
      else if (btn.dataset.tier === '3') tab.textContent = '3 + 3 FREE';
      else tab.textContent = btn.dataset.title || '';
      tab.addEventListener('click', function () {
        self.selectTier(btn.dataset.tier);
      });
      host.appendChild(tab);
    });
  };

  PackBuilder.prototype.optionNames = function (item) {
    if (item.options && item.options.length) {
      return item.options.map(function (o) {
        return typeof o === 'string' ? o : o.name || 'Option';
      });
    }
    var names = [];
    if (item.variants && item.variants.some(function (v) { return v.option1; })) names.push('Option 1');
    if (item.variants && item.variants.some(function (v) { return v.option2; })) names.push('Option 2');
    if (item.variants && item.variants.some(function (v) { return v.option3; })) names.push('Option 3');
    return names;
  };

  PackBuilder.prototype.optionValuesFor = function (item, optIndex) {
    // Cascading: only values available with currently selected prior options
    var values = {};
    (item.variants || []).forEach(function (v) {
      if (optIndex >= 1 && item.option1 && v.option1 !== item.option1) return;
      if (optIndex >= 2 && item.option2 && v.option2 !== item.option2) return;
      var val = v['option' + (optIndex + 1)];
      if (val) values[val] = true;
    });
    return Object.keys(values);
  };

  PackBuilder.prototype.imageForVariant = function (item, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (variant && variant.image_id && item.images && item.images.length) {
      var byId = item.images.find(function (img) {
        return Number(img.id) === Number(variant.image_id);
      });
      if (byId && byId.src) return byId.src;
    }
    if (item.images && item.images.length && variant) {
      var byVariant = item.images.find(function (img) {
        return (img.variant_ids || []).some(function (id) {
          return Number(id) === Number(variant.id);
        });
      });
      if (byVariant && byVariant.src) return byVariant.src;
    }
    return item.image || '';
  };

  PackBuilder.prototype.renderVariantControls = function (item, index) {
    var self = this;
    var wrap = document.createElement('div');
    wrap.className = 'bandify-pack-slot__variants';
    if (!item.variants || !item.variants.length) return wrap;

    var names = this.optionNames(item);
    var shown = 0;
    names.forEach(function (name, optIndex) {
      // Collect all values for this option axis (Drool shows each option type)
      var all = {};
      (item.variants || []).forEach(function (v) {
        var val = v['option' + (optIndex + 1)];
        if (val) all[val] = true;
      });
      var list = Object.keys(all);
      if (!list.length) return;

      // Prefer cascading available values when multiple
      var cascaded = self.optionValuesFor(item, optIndex);
      if (cascaded.length) list = cascaded;

      shown += 1;
      var label = document.createElement('label');
      label.className = 'bandify-pack-slot__variant';
      var caption = document.createElement('span');
      caption.textContent = name;
      var select = document.createElement('select');
      select.setAttribute('data-slot-option', String(optIndex + 1));
      if (list.length === 1) select.disabled = true;
      list.forEach(function (val) {
        var opt = document.createElement('option');
        opt.value = val;
        opt.textContent = val;
        if (item['option' + (optIndex + 1)] === val) opt.selected = true;
        select.appendChild(opt);
      });
      select.addEventListener('change', function () {
        self.changeSlotOptions(index);
      });
      label.appendChild(caption);
      label.appendChild(select);
      wrap.appendChild(label);
    });

    if (shown === 0) wrap.classList.add('is-empty');
    return wrap;
  };

  PackBuilder.prototype.changeSlotOptions = function (index) {
    var item = this.slots[index];
    if (!item || !item.variants) return;

    var row = null;
    var sideSlots = this.sidebar
      ? this.sidebar.querySelectorAll('[data-sidebar-slots] .bandify-pack-slot')
      : [];
    if (sideSlots[index]) row = sideSlots[index];
    if (!row) {
      var mobileSlots = this.root.querySelectorAll('[data-pack-mobile-slots] .bandify-pack-slot');
      if (mobileSlots[index]) row = mobileSlots[index];
    }
    if (!row) return;

    var o1 = item.option1;
    var o2 = item.option2;
    var o3 = item.option3;
    row.querySelectorAll('select[data-slot-option]').forEach(function (sel) {
      var n = Number(sel.getAttribute('data-slot-option'));
      if (n === 1) o1 = sel.value;
      if (n === 2) o2 = sel.value;
      if (n === 3) o3 = sel.value;
    });

    var match =
      item.variants.find(function (v) {
        return (
          (!o1 || v.option1 === o1) &&
          (!o2 || !v.option2 || v.option2 === o2) &&
          (!o3 || !v.option3 || v.option3 === o3)
        );
      }) ||
      item.variants.find(function (v) {
        return v.option1 === o1 && (!o2 || v.option2 === o2);
      }) ||
      item.variants.find(function (v) {
        return v.option1 === o1;
      });

    if (!match) return;

    item.id = match.id;
    item.price = Number(match.price) || 0;
    item.compare = Number(match.compare_at_price) || 0;
    item.option1 = match.option1 || null;
    item.option2 = match.option2 || null;
    item.option3 = match.option3 || null;
    item.image = this.imageForVariant(item, match) || item.image;

    this.renderAllSlots();
    this.updateCtas();
    this.renderGrid();
  };

  PackBuilder.prototype.renderSlotInto = function (host, clickableEmpty) {
    if (!host) return;
    var self = this;
    var unlocked = this.freeUnlocked();
    host.innerHTML = '';

    this.slots.forEach(function (item, index) {
      var isFree = index >= self.paid;
      var lockedFree = isFree && !unlocked;
      var isActive =
        self.building &&
        index === self.pickingIndex &&
        !item &&
        (!isFree || unlocked);

      if (!item) {
        var empty = document.createElement(clickableEmpty && !lockedFree ? 'button' : 'div');
        if (empty.tagName === 'BUTTON') empty.type = 'button';
        empty.className =
          'bandify-pack-slot is-empty' +
          (isActive ? ' is-active' : '') +
          (isFree ? ' is-free-empty' : '') +
          (lockedFree ? ' is-locked' : '');

        var label;
        if (lockedFree) {
          label = tpl(self.i18n.emptyFreeLocked || 'FREE band [n] — unlock after paid bands', {
            n: String(index - self.paid + 1)
          });
        } else if (isFree) {
          label = tpl(self.i18n.emptyFree || '+ FREE band [n]', {
            n: String(index - self.paid + 1)
          });
        } else if (isActive) {
          label = tpl(self.i18n.activeSlot || '+ Band [n]: pick from the grid', {
            n: String(index + 1)
          });
        } else {
          label = self.i18n.emptyPaid || 'Choose a band';
        }

        empty.innerHTML = '<div class="bandify-pack-slot__meta"><strong></strong><span></span></div>';
        empty.querySelector('strong').textContent = label;
        if (isFree) {
          // Empty free slot: fixed marketing value (not PDP base price)
          empty.querySelector('span').textContent =
            self.emptyFreeValueLabel();
        }

        if (clickableEmpty && !lockedFree) {
          empty.addEventListener('click', function () {
            self.focusSlot(index);
          });
        }
        host.appendChild(empty);
        return;
      }

      var row = document.createElement('div');
      row.className = 'bandify-pack-slot is-filled' + (isFree ? ' is-free-filled' : '');
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        row.appendChild(img);
      }
      var meta = document.createElement('div');
      meta.className = 'bandify-pack-slot__meta';
      var title = document.createElement('strong');
      title.textContent = item.title || 'Band';
      meta.appendChild(title);

      var priceLine = document.createElement('span');
      priceLine.className = 'bandify-pack-slot__price';
      if (isFree) {
        // Strike full retail (client: savings from full price).
        var freeRetail = self.slotRetailPrice(item) || item.price || self.basePrice;
        priceLine.innerHTML =
          '<s>' +
          money(freeRetail, self.moneyFormat) +
          '</s> <em>' +
          (self.i18n.freeLabel || 'FREE') +
          '</em>';
      } else {
        // Show real product price in slots (same as grid). Pack % off is only in Total.
        var unit = item.price || self.basePrice;
        priceLine.innerHTML =
          (item.compare > unit
            ? '<s>' + money(item.compare, self.moneyFormat) + '</s> '
            : '') +
          '<b>' +
          money(unit, self.moneyFormat) +
          '</b>';
      }
      meta.appendChild(priceLine);
      row.appendChild(meta);

      // Drool-style: show every product option (Size, Colour, Strap, etc.)
      var variantControls = self.renderVariantControls(item, index);
      if (variantControls && variantControls.children.length) {
        row.appendChild(variantControls);
      }

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'bandify-pack-slot__remove';
      remove.setAttribute('aria-label', 'Remove');
      remove.textContent = '×';
      remove.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        self.removeSlot(index, row);
      });
      row.appendChild(remove);
      host.appendChild(row);
    });
  };

  PackBuilder.prototype.removeSlot = function (index, rowEl) {
    var self = this;
    if (this._removing) return;
    this._removing = true;

    var nodes = [];
    if (rowEl) nodes.push(rowEl);
    // Removing a paid band also clears free bands — animate those too
    if (index < this.paid) {
      document
        .querySelectorAll(
          '[data-sidebar-slots] .bandify-pack-slot.is-free-filled, [data-pack-mobile-slots] .bandify-m-slot.is-filled.is-free'
        )
        .forEach(function (node) {
          if (nodes.indexOf(node) === -1) nodes.push(node);
        });
    }
    nodes.forEach(function (node) {
      node.classList.add('is-removing');
    });

    window.setTimeout(function () {
      self.slots[index] = null;
      if (index < self.paid) {
        for (var f = self.paid; f < self.totalSlots; f++) self.slots[f] = null;
      }
      self.rememberCurrentPack();
      self.pickingIndex = index;
      self._removing = false;
      self.renderAllSlots();
      self.updateCtas();
      self.updateWorkspaceMeta();
      self.loadProducts(true);
    }, 220);
  };

  PackBuilder.prototype.focusSlot = function (index) {
    var isFree = index >= this.paid;
    if (isFree && !this.freeUnlocked()) return;
    this.pickingIndex = index;
    if (isDesktop()) {
      if (!this.building) this.enterBuildMode();
      else {
        this.updateWorkspaceMeta();
        this.renderAllSlots();
        this.loadProducts(true);
      }
    } else {
      this.openMobileDrawer(index);
    }
  };

  PackBuilder.prototype.renderAllSlots = function () {
    this.renderMobileSlots(qs(this.root, '[data-pack-mobile-slots]'));
    this.renderSlotInto(this.sidebar ? qs(this.sidebar, '[data-sidebar-slots]') : null, true);
  };

  PackBuilder.prototype.renderMobileSlots = function (host) {
    if (!host) return;
    var self = this;
    var unlocked = this.freeUnlocked();
    var phase = this.phase();
    host.innerHTML = '';

    this.slots.forEach(function (item, index) {
      var isFree = index >= self.paid;
      var lockedFree = isFree && !unlocked;
      var paidNum = index + 1;
      var freeNum = index - self.paid + 1;

      if (!item) {
        var empty = document.createElement(lockedFree ? 'div' : 'button');
        if (empty.tagName === 'BUTTON') empty.type = 'button';
        empty.className =
          'bandify-m-slot is-empty' +
          (isFree ? ' is-free' : '') +
          (lockedFree ? ' is-locked' : '') +
          (index === self.pickingIndex && !lockedFree ? ' is-active' : '');

        var plus = document.createElement('span');
        plus.className = 'bandify-m-slot__plus';
        plus.textContent = '+';
        var meta = document.createElement('div');
        meta.className = 'bandify-m-slot__meta';
        var eyebrow = document.createElement('span');
        eyebrow.className = 'bandify-m-slot__eyebrow';
        eyebrow.textContent = isFree ? 'FREE BAND ' + freeNum : 'BAND ' + paidNum;
        var label = document.createElement('strong');
        if (lockedFree) label.textContent = 'Unlock after paid bands';
        else if (isFree) label.textContent = 'Add FREE band ' + freeNum;
        else label.textContent = 'Add your ' + paidNum + (paidNum === 1 ? 'st' : paidNum === 2 ? 'nd' : paidNum === 3 ? 'rd' : 'th') + ' band';
        meta.appendChild(eyebrow);
        meta.appendChild(label);
        if (isFree) {
          var freePrice = document.createElement('span');
          freePrice.className = 'bandify-m-slot__free-price';
          freePrice.textContent = self.emptyFreeValueLabel();
          meta.appendChild(freePrice);
        }
        empty.appendChild(plus);
        empty.appendChild(meta);
        if (!lockedFree) {
          empty.addEventListener('click', function () {
            self.focusSlot(index);
          });
        }
        host.appendChild(empty);
        return;
      }

      var row = document.createElement('div');
      row.className = 'bandify-m-slot is-filled' + (isFree ? ' is-free' : '');
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        row.appendChild(img);
      }
      var filledMeta = document.createElement('div');
      filledMeta.className = 'bandify-m-slot__meta';
      var eye = document.createElement('span');
      eye.className = 'bandify-m-slot__eyebrow';
      eye.textContent = isFree ? 'FREE BAND ' + freeNum : 'BAND ' + paidNum;
      var title = document.createElement('strong');
      title.textContent = item.title || 'Band';
      var price = document.createElement('span');
      price.className = 'bandify-m-slot__price';
      if (isFree) {
        var mFreeRetail = self.slotRetailPrice(item) || item.price || self.basePrice;
        price.innerHTML =
          '<s>' + money(mFreeRetail, self.moneyFormat) + '</s> <em>FREE</em>';
      } else {
        price.innerHTML = '<b>' + money(item.price || self.basePrice, self.moneyFormat) + '</b>';
      }
      filledMeta.appendChild(eye);
      filledMeta.appendChild(title);
      filledMeta.appendChild(price);
      row.appendChild(filledMeta);

      var actions = document.createElement('div');
      actions.className = 'bandify-m-slot__actions';

      if (phase !== 'complete') {
        var change = document.createElement('button');
        change.type = 'button';
        change.className = 'bandify-m-slot__change';
        change.textContent = 'Change';
        change.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          self.slots[index] = null;
          if (index < self.paid) {
            for (var f = self.paid; f < self.totalSlots; f++) self.slots[f] = null;
          }
          self.rememberCurrentPack();
          self.pickingIndex = index;
          self.renderAllSlots();
          self.updateCtas();
          self.openMobileDrawer(index);
        });
        actions.appendChild(change);
      }

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'bandify-m-slot__remove';
      remove.setAttribute('aria-label', 'Remove band');
      remove.textContent = 'Remove';
      remove.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        self.removeSlot(index, row);
      });
      actions.appendChild(remove);
      row.appendChild(actions);
      host.appendChild(row);
    });
  };

  PackBuilder.prototype.updateWorkspaceMeta = function () {
    if (!this.workspace) return;
    var title = qs(this.workspace, '[data-workspace-title]');
    var note = qs(this.workspace, '[data-workspace-note]');
    var map = this.mapVars();
    var phase = this.phase();
    var progressTpl =
      phase === 'free'
        ? this.i18n.progressFree || 'Choose FREE band [current] of [slots]'
        : this.i18n.progress || 'Choose band [current] of [slots]';
    if (/\[total\]/.test(progressTpl) && !/\[slots\]/.test(progressTpl)) {
      progressTpl = progressTpl.replace(/\[total\]/g, '[slots]');
    }
    if (title) title.textContent = tpl(progressTpl, map);
    if (note) {
      note.textContent = this.watchSize
        ? tpl(this.i18n.sizeApplied || 'Size [size] applied to every band', map)
        : '';
      note.hidden = !this.watchSize;
    }
    if (this.drawer) {
      var dTitle = qs(this.drawer, '[data-drawer-title]');
      var dNote = qs(this.drawer, '[data-drawer-note]');
      // Mobile picker titles: "Choose band 2 of 2" for paid, FREE wording for free phase
      var pickerTpl =
        phase === 'free' || (this.pickingIndex >= this.paid && this.freeUnlocked())
          ? 'Choose FREE band [n] of [free]'
          : 'Choose band [n] of [paid]';
      var pickerMap = Object.assign({}, map, {
        n: String(
          this.pickingIndex >= this.paid
            ? this.pickingIndex - this.paid + 1
            : this.pickingIndex + 1
        )
      });
      if (dTitle) dTitle.textContent = tpl(pickerTpl, pickerMap);
      if (dNote) {
        if (this.watchSize) {
          dNote.hidden = false;
          dNote.textContent = tpl(
            this.i18n.sizeApplied || 'Size [size] applied to every band',
            map
          );
        } else {
          dNote.hidden = true;
        }
      }
    }
  };

  PackBuilder.prototype.onCta = function () {
    if (this.totalSlots <= 1) {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form && form.requestSubmit) form.requestSubmit();
      else if (form) form.submit();
      else this.addSingleToCart();
      return;
    }

    // Desktop: "Build my pack" must ALWAYS open the builder first.
    // Never ATC from the pre-build CTA (restored complete packs were skipping the builder).
    if (isDesktop()) {
      if (!this.building) {
        this.enterBuildMode();
        return;
      }
      if (this.phase() === 'complete') {
        this.addPackToCart();
      }
      return;
    }

    // Mobile: complete → cart; otherwise open picker (including paid phase)
    if (this.phase() === 'complete') {
      this.addPackToCart();
      return;
    }
    var next = this.slots.findIndex(
      function (s, i) {
        if (s) return false;
        if (i >= this.paid && !this.freeUnlocked()) return false;
        return true;
      }.bind(this)
    );
    this.openMobileDrawer(next < 0 ? 0 : next);
  };

  PackBuilder.prototype.onSidebarCta = function () {
    if (this.phase() === 'complete') this.addPackToCart();
  };

  PackBuilder.prototype.enterBuildMode = function () {
    if (this.totalSlots <= 1) return;
    // Desktop-only gallery swap — never flip mobile into desktop build layout
    if (!isDesktop()) {
      var next = this.pickingIndex;
      if (next == null || next < 0 || this.slots[next]) {
        next = this.slots.findIndex(
          function (s, i) {
            if (s) return false;
            if (i >= this.paid && !this.freeUnlocked()) return false;
            return true;
          }.bind(this)
        );
      }
      this.renderAllSlots();
      this.updateCtas();
      if (next >= 0) this.openMobileDrawer(next);
      return;
    }
    this.building = true;
    document.documentElement.classList.add('bandify-pack-building');
    if (this.workspace) this.workspace.hidden = false;
    if (this.sidebar) this.sidebar.hidden = false;
    if (this.pickingIndex == null || this.pickingIndex < 0 || this.slots[this.pickingIndex]) {
      this.pickingIndex = this.slots.findIndex(
        function (s, i) {
          if (s) return false;
          if (i >= this.paid && !this.freeUnlocked()) return false;
          return true;
        }.bind(this)
      );
    }
    this.renderSidebarTabs();
    this.renderAllSlots();
    this.updateCtas();
    this.updateWorkspaceMeta();
    this.loadProducts(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  PackBuilder.prototype.exitBuildMode = function () {
    this.building = false;
    document.documentElement.classList.remove('bandify-pack-building');
    if (this.workspace) this.workspace.hidden = true;
    if (this.sidebar) this.sidebar.hidden = true;
    this.closeMobileDrawer();
    this.updateCtas();
  };

  PackBuilder.prototype.openMobileDrawer = function (index) {
    var self = this;
    if (!this.drawer || isDesktop()) return;
    if (this.drawer.parentElement !== document.body) {
      document.body.appendChild(this.drawer);
    }
    this.pickingIndex = typeof index === 'number' ? index : 0;
    if (this._drawerCloseTimer) {
      clearTimeout(this._drawerCloseTimer);
      this._drawerCloseTimer = null;
    }
    this.drawer.hidden = false;
    document.documentElement.classList.add('bandify-pack-drawer-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    this.syncDrawerFilters();
    this.updateWorkspaceMeta();
    this.loadProducts(true);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (self.drawer) self.drawer.classList.add('is-open');
      });
    });
  };

  PackBuilder.prototype.closeMobileDrawer = function () {
    var self = this;
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    document.documentElement.classList.remove('bandify-pack-drawer-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (this._drawerCloseTimer) clearTimeout(this._drawerCloseTimer);
    this._drawerCloseTimer = setTimeout(function () {
      if (self.drawer && !self.drawer.classList.contains('is-open')) {
        self.drawer.hidden = true;
      }
      self._drawerCloseTimer = null;
    }, 280);
  };

  PackBuilder.prototype.syncDrawerFilters = function () {
    if (!this.drawer || !this.workspace) return;
    var host = qs(this.drawer, '[data-drawer-filters]');
    var source = qs(this.workspace, '[data-pack-filters]');
    if (!host || !source) return;
    host.innerHTML = source.innerHTML;
    var self = this;
    host.querySelectorAll('[data-material-filter]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.materialFilter === self.materialFilter);
      btn.addEventListener('click', function () {
        self.setMaterialFilter(btn.dataset.materialFilter);
      });
    });
    this.syncFilterVisibility();
  };

  // Premium / excluded from FREE picker (client list).
  // Colour also hidden in free phase — chips were empty on mobile; use
  // Bestsellers / Milanese / Floral / Sport Band so customers can scroll favourites.
  var FREE_PHASE_HIDDEN_FILTERS = {
    Titanium: true,
    Leather: true,
    Crystal: true,
    'Luxury Steel': true,
    Steel: true,
    colour: true
  };

  // Bestsellers first for scroll (paid + free). Client: Bestsellers / Milanese / Floral / Sport Band
  var FAVOURITE_FILTER_ORDER = ['best-sellers', 'Milanese', 'Floral', 'Sport'];

  // Paid-phase: material tabs load their own collections
  var PAID_FILTER_COLLECTIONS = {
    Milanese: 'milanese-loop-apple-watch-bands',
    Floral: 'floral-apple-watch-band',
    Sport: 'sport-apple-watch-band',
    Titanium: 'titanium-apple-watch-band',
    Leather: 'leather-buckle-classic-apple-watch-bands'
  };

  PackBuilder.prototype.setMaterialFilter = function (filter) {
    filter = filter || 'best-sellers';
    // Free phase: never allow premium material tabs
    if (this.shouldUseFreeCollection() && FREE_PHASE_HIDDEN_FILTERS[filter]) {
      filter = 'best-sellers';
    }
    this.materialFilter = filter;
    this.colourChip = '';
    var self = this;
    this.syncFilterVisibility();
    [this.workspace, this.drawer].filter(Boolean).forEach(function (root) {
      root.querySelectorAll('[data-material-filter]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.materialFilter === self.materialFilter);
      });
    });
    this.renderColourChips();
    this.loadProducts(false);
  };

  PackBuilder.prototype.shouldUseFreeCollection = function () {
    // Once paid slots are filled, always use the free collection (Drool free phase),
    // including when the pack is complete so free picks stay available to swap.
    return this.freeUnlocked();
  };

  PackBuilder.prototype.syncFilterVisibility = function () {
    var freePhase = this.shouldUseFreeCollection();
    if (freePhase && FREE_PHASE_HIDDEN_FILTERS[this.materialFilter]) {
      this.materialFilter = 'best-sellers';
    }
    [this.workspace, this.drawer].filter(Boolean).forEach(function (root) {
      var host = qs(root, '[data-pack-filters], [data-drawer-filters]') || root;
      var buttons = [];
      root.querySelectorAll('[data-material-filter]').forEach(function (btn) {
        var key = btn.dataset.materialFilter || '';
        var hide = freePhase && !!FREE_PHASE_HIDDEN_FILTERS[key];
        btn.hidden = hide;
        btn.style.display = hide ? 'none' : '';
        if (hide) btn.classList.remove('is-active');
        if (!hide) buttons.push(btn);
      });
      // Paid + free: Bestsellers → Milanese → Floral → Sport Band first (scroll), then the rest
      if (buttons.length && host) {
        var placed = {};
        FAVOURITE_FILTER_ORDER.forEach(function (key) {
          buttons.forEach(function (btn) {
            if (btn.dataset.materialFilter === key) {
              host.appendChild(btn);
              placed[key] = true;
            }
          });
        });
        buttons.forEach(function (btn) {
          var key = btn.dataset.materialFilter || '';
          if (!placed[key]) host.appendChild(btn);
        });
      }
    });
  };

  // Material filters load their own collections in PAID phase only.
  // Free phase always stays on Bundle Free Bands (filters only narrow within it).
  PackBuilder.prototype.filterCollectionHandle = function () {
    if (this.shouldUseFreeCollection()) return '';
    return PAID_FILTER_COLLECTIONS[this.materialFilter] || '';
  };

  PackBuilder.prototype.activeCollectionHandle = function () {
    if (this.shouldUseFreeCollection()) {
      return this.freeCollection || this.paidCollection || 'all';
    }
    var materialHandle = this.filterCollectionHandle();
    if (materialHandle) return materialHandle;
    return this.paidCollection || 'all';
  };

  PackBuilder.prototype.cacheKey = function (handle) {
    return String(activeCurrency() || 'shop') + '::' + String(handle || '');
  };

  PackBuilder.prototype.rememberCollectionCache = function (handle, products) {
    this.productCache = this.productCache || {};
    this.productCache[this.cacheKey(handle)] = products || [];
    // Bind caches to the collection handle — never by phase alone
    // (avoids stale paid responses polluting freeCache after free unlock).
    if (handle && this.freeCollection && handle === this.freeCollection) {
      this.freeCache = products || [];
    } else if (handle && this.paidCollection && handle === this.paidCollection) {
      this.paidCache = products || [];
    } else if (handle && PAID_FILTER_COLLECTIONS) {
      var paidHandles = {};
      Object.keys(PAID_FILTER_COLLECTIONS).forEach(function (k) {
        paidHandles[PAID_FILTER_COLLECTIONS[k]] = true;
      });
      if (paidHandles[handle] && !this.paidCache) this.paidCache = products || [];
    }
  };

  PackBuilder.prototype.applyProductsToGrid = function (handle, products) {
    // Ignore stale responses from an older collection request
    if (handle !== this.activeCollectionHandle()) return;
    this.rememberCollectionCache(handle, products);
    this._activeProducts = products || [];
    if (this._repriceSlotsAfterLoad) {
      this.repriceFilledSlots();
      this._repriceSlotsAfterLoad = false;
    }
    this.syncFilterVisibility();
    this.renderColourChips();
    this.renderGrid();
  };

  PackBuilder.prototype.loadProducts = function (force) {
    var self = this;
    var handle = this.activeCollectionHandle();
    this.productCache = this.productCache || {};
    this._loadProductsSeq = (this._loadProductsSeq || 0) + 1;
    var seq = this._loadProductsSeq;
    var key = this.cacheKey(handle);

    if (!force && this.productCache[key]) {
      this.applyProductsToGrid(handle, this.productCache[key]);
      return;
    }
    this.setGridLoading();
    // Cache-bust so Markets/presentment prices are not served from an old currency response
    var url =
      '/collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=250&currency=' +
      encodeURIComponent(activeCurrency() || '');
    fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (seq !== self._loadProductsSeq) return; // newer request won
        var products = data.products || [];
        self.applyProductsToGrid(handle, products);
      })
      .catch(function () {
        if (seq !== self._loadProductsSeq) return;
        self.setGridMessage('Unable to load bands.');
      });
  };

  // Prefetch free collection so free-slot allowlist is ready before unlock
  PackBuilder.prototype.prefetchFreeCollection = function () {
    var self = this;
    var handle = this.freeCollection;
    if (!handle) return;
    this.productCache = this.productCache || {};
    var key = this.cacheKey(handle);
    if (this.productCache[key] && this.productCache[key].length) {
      this.freeCache = this.productCache[key];
      return;
    }
    var url =
      '/collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=250&currency=' +
      encodeURIComponent(activeCurrency() || '');
    fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var products = data.products || [];
        self.rememberCollectionCache(handle, products);
        if (self._repriceSlotsAfterLoad) self.repriceFilledSlots();
      })
      .catch(function () {});
  };

  PackBuilder.prototype.gridHosts = function () {
    var hosts = [];
    // Mobile: only paint drawer grid (avoids hidden workspace leakage)
    if (!isDesktop()) {
      if (this.drawer && !this.drawer.hidden) {
        hosts.push(qs(this.drawer, '[data-drawer-grid]'));
      }
      return hosts.filter(Boolean);
    }
    if (this.workspace) hosts.push(qs(this.workspace, '[data-pack-grid]'));
    return hosts.filter(Boolean);
  };

  PackBuilder.prototype.setGridLoading = function () {
    this.gridHosts().forEach(function (grid) {
      grid.innerHTML = '<p class="bandify-pack-workspace__loading">Loading bands…</p>';
    });
  };

  PackBuilder.prototype.setGridMessage = function (msg) {
    this.gridHosts().forEach(function (grid) {
      grid.innerHTML = '<p class="bandify-pack-workspace__loading">' + msg + '</p>';
    });
  };

  PackBuilder.prototype.currentProducts = function () {
    if (this._activeProducts && this._activeProducts.length) {
      return this._activeProducts.slice();
    }
    var handle = this.activeCollectionHandle();
    if (this.productCache && this.productCache[handle]) {
      return this.productCache[handle].slice();
    }
    var useFree = this.shouldUseFreeCollection();
    return ((useFree ? this.freeCache : this.paidCache) || []).slice();
  };

  PackBuilder.prototype.productMatches = function (product) {
    // Paid phase: material tab already loaded that collection — show all from it
    if (this.filterCollectionHandle()) return true;
    if (this.materialFilter === 'best-sellers') {
      if (!this.colourChip) return true;
      return (product.title + ' ' + (product.tags || []).join(' '))
        .toLowerCase()
        .includes(this.colourChip.toLowerCase());
    }
    if (this.materialFilter === 'colour') {
      if (!this.colourChip) return true;
      return (product.title + ' ' + (product.tags || []).join(' '))
        .toLowerCase()
        .includes(this.colourChip.toLowerCase());
    }
    // Free phase (and Best sellers without a dedicated collection):
    // narrow Bundle Free Bands by material keyword — never load premium collections.
    var needle = String(this.materialFilter || '').toLowerCase();
    // "Sport Band" tab uses data-material-filter="Sport"
    if (needle === 'sport') needle = 'sport';
    if (needle === 'floral') needle = 'floral';
    var hay = (
      product.title +
      ' ' +
      (product.product_type || '') +
      ' ' +
      (product.tags || []).join(' ') +
      ' ' +
      (product.handle || '')
    ).toLowerCase();
    return hay.indexOf(needle) > -1;
  };

  PackBuilder.prototype.isAllowedInFreeSlot = function (item) {
    if (!item) return false;
    var hay = (
      String(item.title || '') +
      ' ' +
      String(item.handle || '') +
      ' ' +
      String(item.product_type || '')
    ).toLowerCase();
    // Hard deny premium / excluded free collections (client list)
    var blocked = [
      'titanium',
      'luxury steel',
      'luxury-steel',
      'crystal',
      'classic stainless',
      'stainless-steel',
      'stainless steel',
      'leather buckle',
      'leather classic',
      'leather-buckle',
      'alpine loop',
      'alpine-loop'
    ];
    // Solo Loop (not Braided Solo Loop)
    if (
      (hay.indexOf('solo loop') > -1 || hay.indexOf('solo-loop') > -1) &&
      hay.indexOf('braided') === -1
    ) {
      return false;
    }
    for (var i = 0; i < blocked.length; i++) {
      if (hay.indexOf(blocked[i]) > -1) return false;
    }
    // Must be in Bundle Free Bands collection cache when available
    var cache =
      (this.productCache && this.freeCollection && this.productCache[this.freeCollection]) ||
      this.freeCache ||
      [];
    if (cache.length) {
      var pid = Number(item.productId || item.product_id);
      var handle = String(item.handle || '').toLowerCase();
      return cache.some(function (p) {
        return Number(p.id) === pid || String(p.handle || '').toLowerCase() === handle;
      });
    }
    // Cache not ready — allow only after deny-list (soft bands / cases)
    return true;
  };

  PackBuilder.prototype.colourChipHosts = function () {
    var hosts = [];
    if (this.workspace) {
      var w = qs(this.workspace, '[data-filter-chips]');
      if (w) hosts.push(w);
    }
    if (this.drawer) {
      var d = qs(this.drawer, '[data-drawer-chips]');
      if (d) hosts.push(d);
    }
    return hosts;
  };

  // Match theme.liquid swatch classes: "Space Black" → classes Space + Black (.Space.Black)
  function colourSwatchClassList(name) {
    return String(name || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .join(' ');
  }

  PackBuilder.prototype.renderColourChips = function () {
    var hosts = this.colourChipHosts();
    if (!hosts.length) return;
    var self = this;
    if (this.materialFilter !== 'colour') {
      hosts.forEach(function (chips) {
        chips.hidden = true;
        chips.innerHTML = '';
      });
      return;
    }
    var colours = {};
    this.currentProducts().forEach(function (p) {
      (p.options || []).forEach(function (opt) {
        var name = String(opt.name || opt || '').toLowerCase();
        // products.json: options can be strings ("Colour") or {name, values}
        if (typeof opt === 'string') {
          if (name.indexOf('color') > -1 || name.indexOf('colour') > -1) {
            (p.variants || []).forEach(function (v) {
              [v.option1, v.option2, v.option3].forEach(function (val) {
                if (val && !/^\d/.test(val) && !/mm/i.test(val)) colours[val] = true;
              });
            });
          }
          return;
        }
        if (name.indexOf('color') > -1 || name.indexOf('colour') > -1) {
          (opt.values || []).forEach(function (v) {
            if (v) colours[v] = true;
          });
        }
      });
      var parts = String(p.title || '').split('|');
      if (parts[1]) colours[parts[1].trim()] = true;
    });
    var values = Object.keys(colours).sort();
    hosts.forEach(function (host) {
      host.hidden = values.length === 0;
      host.innerHTML = '';
      values.forEach(function (value) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className =
          'bandify-pack-chip bandify-pack-chip--swatch' +
          (self.colourChip === value ? ' is-active' : '');
        chip.setAttribute('aria-label', value);
        chip.title = value;

        var swatch = document.createElement('span');
        swatch.className = 'bandify-pack-chip__swatch ' + colourSwatchClassList(value);
        swatch.setAttribute('aria-hidden', 'true');

        var label = document.createElement('span');
        label.className = 'bandify-pack-chip__label';
        label.textContent = value;

        chip.appendChild(swatch);
        chip.appendChild(label);
        chip.addEventListener('click', function () {
          self.colourChip = self.colourChip === value ? '' : value;
          self.renderColourChips();
          self.renderGrid();
        });
        host.appendChild(chip);
      });
    });
  };

  PackBuilder.prototype.pickVariantFromProduct = function (product, preferredId) {
    var variants = product.variants || [];
    if (!variants.length) return null;
    if (preferredId) {
      var preferred = variants.find(function (v) {
        return Number(v.id) === Number(preferredId);
      });
      if (preferred) return preferred;
    }
    var size = (this.watchSize || '').toLowerCase();
    if (size) {
      var match = variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(Boolean).join(' ').toLowerCase();
        if (v.available === false) return false;
        if (/38|40|41/.test(size)) return /38|40|41/.test(opts);
        if (/42|44|45|46|49/.test(size)) return /42|44|45|46|49/.test(opts);
        return opts.indexOf(size.replace(/\s/g, '')) > -1;
      });
      if (match) return match;
    }
    return (
      variants.find(function (v) {
        return v.available !== false;
      }) || variants[0]
    );
  };

  PackBuilder.prototype.emptyFreeValueLabel = function () {
    var max = 0;
    (this.freeCache || []).forEach(function (p) {
      (p.variants || []).forEach(function (v) {
        var c = Math.max(priceToCents(v.compare_at_price), priceToCents(v.price));
        if (c > max) max = c;
      });
    });
    // Fallback: AUD $40 marketing value only until free collection is loaded
    if (!max) max = 4000;
    return 'up to ' + money(max, this.moneyFormat) + ' value';
  };

  PackBuilder.prototype.slotFromProduct = function (product, variant, isFree) {
    if (!variant) return null;
    // Always normalize via priceToCents — presentment amounts from products.json
    // must match the selected country (GBP/USD/PKR), never a previous currency cache.
    var price = priceToCents(variant.price);
    var compare = variant.compare_at_price ? priceToCents(variant.compare_at_price) : 0;
    var img =
      (variant.featured_image && variant.featured_image.src) ||
      (product.featured_image && (product.featured_image.src || product.featured_image)) ||
      (product.images && product.images[0] && (product.images[0].src || product.images[0])) ||
      '';
    var options = (product.options || []).map(function (o) {
      return typeof o === 'string' ? o : o.name;
    });
    return {
      id: variant.id,
      productId: product.id,
      handle: product.handle || '',
      product_type: product.product_type || product.type || '',
      title: product.title,
      image: img,
      price: price,
      compare: compare,
      isFree: !!isFree,
      option1: variant.option1 || null,
      option2: variant.option2 || null,
      option3: variant.option3 || null,
      variants: (product.variants || []).map(function (v) {
        return {
          id: v.id,
          price: priceToCents(v.price),
          compare_at_price: v.compare_at_price ? priceToCents(v.compare_at_price) : 0,
          option1: v.option1,
          option2: v.option2,
          option3: v.option3,
          available: v.available !== false,
          featured_image: v.featured_image || null
        };
      }),
      options: options
    };
  };

  PackBuilder.prototype.renderGrid = function () {
    var self = this;
    var phase = this.phase();
    var products = this.currentProducts().filter(function (p) {
      return self.productMatches(p);
    });
    var hosts = this.gridHosts();
    if (!hosts.length) return;
    if (!products.length) {
      this.setGridMessage('No bands match these filters.');
      return;
    }

    var inFreePhase = phase === 'free' || this.freeUnlocked();
    var addLabel = inFreePhase
      ? this.i18n.addFreeLabel || '+ Add FREE'
      : this.i18n.addLabel || '+ Add';
    var addedLabel = this.i18n.addedLabel || 'Added';

    hosts.forEach(function (grid) {
      grid.innerHTML = '';
      products.forEach(function (p) {
        var variant = self.pickVariantFromProduct(p);
        if (!variant) return;
        var imgUrl = p.images && p.images[0] ? p.images[0].src : '';
        var priceCents = dollarsToCents(variant.price);
        var compareCents = variant.compare_at_price
          ? dollarsToCents(variant.compare_at_price)
          : 0;
        var already = self.slots.some(function (s) {
          return s && Number(s.productId) === Number(p.id);
        });

        var card = document.createElement('div');
        card.className = 'bandify-pack-card' + (already ? ' is-added' : '');
        card.setAttribute('role', 'group');
        card.innerHTML =
          '<div class="bandify-pack-card__media">' +
          (imgUrl
            ? '<img class="bandify-pack-card__img" src="' +
              imgUrl +
              '" alt="" loading="lazy" decoding="async" width="400" height="400">'
            : '') +
          '</div>' +
          '<div class="bandify-pack-card__meta">' +
          '<div class="bandify-pack-card__title"></div>' +
          '<div class="bandify-pack-card__price"></div>' +
          '<button type="button" class="bandify-pack-card__add"></button>' +
          '</div>';
        card.querySelector('.bandify-pack-card__title').textContent = p.title;
        var priceEl = card.querySelector('.bandify-pack-card__price');
        priceEl.innerHTML =
          money(priceCents, self.moneyFormat) +
          (compareCents > priceCents ? ' <s>' + money(compareCents, self.moneyFormat) + '</s>' : '');
        var addBtn = card.querySelector('.bandify-pack-card__add');
        addBtn.textContent = already ? addedLabel : addLabel;
        addBtn.classList.toggle('is-added', already);
        // Once in the pack, never add again (mobile + desktop)
        if (already) {
          addBtn.disabled = true;
          addBtn.setAttribute('aria-disabled', 'true');
        }
        var addProduct = function () {
          if (already) return;
          if (
            self.slots.some(function (s) {
              return s && Number(s.productId) === Number(p.id);
            })
          ) {
            return;
          }
          var slotItem = self.slotFromProduct(p, variant, phase === 'free');
          // products.json prices are dollars
          slotItem.price = dollarsToCents(variant.price);
          slotItem.compare = variant.compare_at_price
            ? dollarsToCents(variant.compare_at_price)
            : 0;
          slotItem.images = (p.images || []).map(function (img) {
            return {
              id: img.id,
              src: img.src,
              variant_ids: img.variant_ids || []
            };
          });
          slotItem.variants = (p.variants || []).map(function (v) {
            return {
              id: v.id,
              price: dollarsToCents(v.price),
              compare_at_price: v.compare_at_price ? dollarsToCents(v.compare_at_price) : 0,
              option1: v.option1,
              option2: v.option2,
              option3: v.option3,
              available: v.available !== false,
              featured_image: v.featured_image
                ? { src: v.featured_image.src || v.featured_image }
                : null,
              image_id: v.image_id || (v.featured_image && v.featured_image.id) || null
            };
          });
          slotItem.options = (p.options || []).map(function (o) {
            return typeof o === 'string' ? o : o.name;
          });
          slotItem.option1 = variant.option1 || null;
          slotItem.option2 = variant.option2 || null;
          slotItem.option3 = variant.option3 || null;
          slotItem.image = self.imageForVariant(slotItem, {
            id: variant.id,
            featured_image: variant.featured_image,
            image_id: variant.image_id
          }) || imgUrl;
          self.addToSlot(slotItem);
        };
        addBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          addProduct();
        });
        card.addEventListener('click', function (event) {
          if (event.target && event.target.closest && event.target.closest('button')) return;
          addProduct();
        });
        grid.appendChild(card);
      });
    });
  };

  PackBuilder.prototype.addToSlot = function (item) {
    var phase = this.phase();
    var idx = this.pickingIndex;

    if (phase === 'paid') {
      if (idx == null || idx < 0 || idx >= this.paid || this.slots[idx]) {
        idx = -1;
        for (var i = 0; i < this.paid; i++) {
          if (!this.slots[i]) {
            idx = i;
            break;
          }
        }
      }
    } else if (phase === 'free') {
      if (idx == null || idx < this.paid || this.slots[idx]) {
        idx = -1;
        for (var j = this.paid; j < this.totalSlots; j++) {
          if (!this.slots[j]) {
            idx = j;
            break;
          }
        }
      }
    } else {
      return;
    }

    if (idx === -1) return;
    // Free slots: only Bundle Free Bands products (no Titanium / Leather / premium)
    if (idx >= this.paid && !this.isAllowedInFreeSlot(item)) {
      return;
    }
    // Hard rule: each product only once per pack
    var exists = this.slots.some(function (s) {
      return s && Number(s.productId) === Number(item.productId);
    });
    if (exists) return;

    item.isFree = idx >= this.paid;
    this.slots[idx] = item;
    this.rememberCurrentPack();

    // Advance to next empty allowed slot
    var next = -1;
    if (this.paidFilledCount() < this.paid) {
      for (var a = 0; a < this.paid; a++) if (!this.slots[a]) { next = a; break; }
    } else {
      for (var b = this.paid; b < this.totalSlots; b++) if (!this.slots[b]) { next = b; break; }
    }
    this.pickingIndex = next;

    this.renderAllSlots();
    this.updateCtas();
    this.updateWorkspaceMeta();
    this.syncFilterVisibility();
    // When unlocking free phase, reload free collection (never premium tabs)
    this.loadProducts(true);

    // Mobile: close sheet → show updated slots. Do NOT auto-open next —
    // customer taps the next empty slot when ready.
    if (!isDesktop()) {
      this.closeMobileDrawer();
      var mobilePanel = qs(this.root, '[data-pack-mobile]');
      if (mobilePanel) {
        try {
          mobilePanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } catch (e2) {}
      }
    }
  };

  PackBuilder.prototype.setAddingState = function (busy) {
    var cta = qs(this.root, '[data-pack-cta]');
    var sideCta = this.sidebar ? qs(this.sidebar, '[data-sidebar-cta]') : null;
    [cta, sideCta].forEach(function (btn) {
      if (!btn) return;
      if (busy) {
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
      } else {
        btn.removeAttribute('aria-busy');
      }
    });
    if (!busy) this.updateCtas();
  };

  PackBuilder.prototype.addSingleToCart = function () {
    var self = this;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var sections = prepareCartSections();
    this.setAddingState(true);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: Number(this.variantId), quantity: 1 }],
        sections: sections
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) throw new Error((result.data && result.data.description) || 'Add failed');
        return fetch(root + 'cart.js').then(function (r) {
          return r.json().then(function (cart) {
            openThemeCartDrawer(cart, result.data);
          });
        });
      })
      .catch(function () {})
      .finally(function () {
        self.setAddingState(false);
      });
  };

  PackBuilder.prototype.addPackToCart = function () {
    var self = this;
    if (this.phase() !== 'complete') return;
    if (this._addingPack) return;
    var missing = this.slots.some(function (slot) {
      return !slot || !slot.id;
    });
    if (missing) {
      alert('Please fill every pack slot before adding to cart.');
      return;
    }
    var packId = 'pack-' + Date.now();
    var linkedVariantIds = [];
    var items = this.slots.map(function (slot, index) {
      // Drool-style cart: title + selected variant only.
      // Do NOT add Option 1 / Option 2 / Watch size props — theme already
      // renders variant.title under the product name (e.g. "38/40/41 / Fits Every Wrist").
      linkedVariantIds.push(String(slot.id));
      var props = {
        _bandify_pack_id: packId,
        _bandify_pack_tier: String(self.paid) + '+' + String(self.free),
        _bandify_slot: String(index + 1),
        _bandify_slot_type: index < self.paid ? 'paid' : 'free',
        _bandify_discount_percent: String(self.percent),
        // Full retail cents — cart drawer Savings uses this (client: retail $80, not sale $40)
        _bandify_retail: String(self.slotRetailPrice(slot) || slot.price || 0)
      };
      if (index >= self.paid) props._bandify_free = 'true';
      return { id: Number(slot.id), quantity: 1, properties: props };
    });

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var sections = prepareCartSections();
    var payload = { items: items };
    if (sections && sections.length) payload.sections = sections;
    this._addingPack = true;
    this.setAddingState(true);

    function postAdd(body) {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      });
    }

    postAdd(payload)
      .then(function (result) {
        // Retry without sections if Section Rendering API rejected the request
        if (!result.ok && payload.sections) {
          delete payload.sections;
          return postAdd(payload);
        }
        return result;
      })
      .then(function (result) {
        if (!result.ok) {
          var msg =
            (result.data && (result.data.description || result.data.message)) ||
            'Could not add pack to cart. Please try again.';
          alert(msg);
          return null;
        }
        // Keep PDP pack slots filled after ATC — only cart removal clears matching slots
        self.cartLinkedPackId = packId;
        self.cartLinkedVariantIds = linkedVariantIds.slice();
        self.rememberCurrentPack();
        self.persistPackState();
        self.renderAllSlots();
        self.updateCtas();
        return fetch(root + 'cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            openThemeCartDrawer(cart, result.data);
          });
      })
      .catch(function () {
        alert('Could not add pack to cart. Please try again.');
      })
      .finally(function () {
        self._addingPack = false;
        self.setAddingState(false);
      });
  };

  PackBuilder.prototype.bindCartSync = function () {
    var self = this;
    var schedule = function () {
      clearTimeout(self._cartSyncTimer);
      self._cartSyncTimer = setTimeout(function () {
        self.syncSlotsFromCart();
      }, 250);
    };
    document.addEventListener('cart:change', schedule);
    document.addEventListener('cart:refresh', schedule);
  };

  PackBuilder.prototype.syncSlotsFromCart = function () {
    var self = this;
    if (!this.cartLinkedPackId) return;
    if (!this.slots || !this.slotHasContent(this.slots)) return;
    if (!this.cartLinkedVariantIds || !this.cartLinkedVariantIds.length) return;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var packItems = (cart.items || []).filter(function (item) {
          var props = item.properties || {};
          return String(props._bandify_pack_id || '') === String(self.cartLinkedPackId);
        });

        var inCartByVariant = {};
        packItems.forEach(function (item) {
          inCartByVariant[String(item.variant_id || item.id)] = item;
        });

        var linkedSet = {};
        self.cartLinkedVariantIds.forEach(function (id) {
          linkedSet[String(id)] = true;
        });

        var changed = false;
        var clearedPaid = false;
        for (var i = 0; i < self.slots.length; i++) {
          var slot = self.slots[i];
          if (!slot || !slot.id) continue;
          var vid = String(slot.id);
          // Only sync bands that were part of the last "Add pack" — don't wipe newly picked slots
          if (!linkedSet[vid]) continue;
          if (inCartByVariant[vid]) continue;

          self.slots[i] = null;
          changed = true;
          if (i < self.paid) clearedPaid = true;
          self.cartLinkedVariantIds = self.cartLinkedVariantIds.filter(function (id) {
            return String(id) !== vid;
          });
        }

        // Pack rule: if a paid band left the cart, free slots from that pack also clear
        if (clearedPaid) {
          for (var f = self.paid; f < self.totalSlots; f++) {
            if (!self.slots[f] || !self.slots[f].id) continue;
            var fvid = String(self.slots[f].id);
            if (linkedSet[fvid] && !inCartByVariant[fvid]) {
              self.slots[f] = null;
              changed = true;
              self.cartLinkedVariantIds = self.cartLinkedVariantIds.filter(function (id) {
                return String(id) !== fvid;
              });
            } else if (linkedSet[fvid]) {
              // paid gone → drop free even if still in cart (customer should re-pick free)
              self.slots[f] = null;
              changed = true;
            }
          }
        }

        if (!packItems.length) {
          self.cartLinkedPackId = null;
          self.cartLinkedVariantIds = [];
        }

        if (changed) {
          var firstEmpty = self.slots.findIndex(function (s, idx) {
            if (s) return false;
            if (idx >= self.paid && !self.freeUnlocked()) return false;
            return true;
          });
          if (firstEmpty >= 0) self.pickingIndex = firstEmpty;
          self.rememberCurrentPack();
          self.persistPackState();
          self.renderAllSlots();
          self.updateCtas();
          self.updateWorkspaceMeta();
          self.updateUnlockBanner();
        } else {
          self.persistPackState();
        }
      })
      .catch(function () {});
  };

  function init() {
    document.querySelectorAll('[data-pack-builder]').forEach(function (root) {
      if (root.__pbInit) return;
      root.__pbInit = true;
      var pb = new PackBuilder(root);
      root.__packBuilder = pb;
    });
  }

  window.BandifyOpenPackTier = function (tier) {
    var root = document.querySelector('[data-pack-builder]');
    if (!root) return false;
    var pb = root.__packBuilder;
    if (!pb) {
      if (!root.__pbInit) {
        root.__pbInit = true;
        pb = new PackBuilder(root);
        root.__packBuilder = pb;
      } else {
        return false;
      }
    }
    pb.selectTier(String(tier || '3'));
    try {
      pb.enterBuildMode();
    } catch (e) {}
    try {
      if (!isDesktop() && pb.openMobileDrawer) pb.openMobileDrawer();
    } catch (e2) {}
    try {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e3) {}
    return true;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
